var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BackContainer, CardContainer, Flipper, FrontContainer } from './subcomponents';
var CardFlip = function (_a) {
    var children = _a.children, isFlipped = _a.isFlipped;
    return (_jsx(CardContainer, __assign({ "$isFlipped": isFlipped }, { children: _jsxs(Flipper, { children: [_jsx(FrontContainer, __assign({ "$isFlipped": isFlipped }, { children: children[0] })), _jsx(BackContainer, __assign({ "$isFlipped": isFlipped }, { children: children[1] }))] }) })));
};
export default CardFlip;
